import { Button, Typography } from "@material-ui/core"
import { Homepage } from "api"
import { trackSkipStoryTwo } from "common/analytics"
import { gsap } from "gsap"
import { useEffect, useRef, useState } from "react"
import MoreInfoWhite from "reusable/icons/MoreInfoWhite"
import styled from "styled-components"
import Blog from "./blog/Blog"
import SwiperMain from "./colorSwiper/SwiperMain"
import MazdaTools from "./mazdaTools/MazdaTools"
import Story, { arrowDown } from "./story/Story"
import TopBanner from "./TopBanner/TopBanner"

const StyledButton = styled(Button)<{ $campaign: boolean }>`
  position: fixed;
  display: inline-flex;
  z-index: 100;
  border-radius: 48px;
  border: none;
  transform: translateX(-100px);
  visibility: hidden;
  opacity: 0;
  left: 20px;
  bottom: 20px;

  div {
    overflow: hidden;
  }

  p {
    color: ${(p) => p?.theme.colors.white};
    font-size: 20px;
    font-weight: 300;
    line-height: 160%;
    letter-spacing: 0.6px;
    flex: 0 0 auto;
    transform: translateX(-100px);
    opacity: 0;
    visibility: hidden;
    transition: all 0.6s ease-in-out;
    padding-inline-end: 8px;
    ${(p) => p.theme.breakpoints.up("md")} {
      padding-inline-end: 16px;
      transition-duration: 0.5s;
    }
  }

  &.show-text {
    p {
      transform: translateX(0);
      opacity: 1;
      visibility: visible;
    }
    &.hide-text {
      p {
        transform: translateX(-100px);
        opacity: 0;
        visibility: hidden;
      }
    }
  }

  &:hover,
  &:focus {
    background-color: transparent !important;
    border: none;

    svg path#arrow {
      stroke: ${(p) => p?.theme.colors.black};
    }
    svg rect {
      fill: ${(p) => p?.theme.colors.white};
      stroke: ${(p) => p?.theme.colors.white};
    }
  }
  /* @media (hover: none) {
    &:hover {
      p {
        transform: translateX(-100px);
        opacity: 0;
        visibility: hidden;
      }
    } */

  svg path#arrow {
    flex: 0 0 auto;
    stroke: ${(p) => p?.theme.colors.white};
    border-color: ${(p) => p?.theme.colors.white};
    animation: ${arrowDown} 5s ease 0s infinite normal forwards;
  }

  &.invert {
    svg path#arrow {
      stroke: ${(p) => p?.theme.colors.black};
      border-color: ${(p) => p?.theme.colors.black};
    }
    p {
      color: ${(p) => p?.theme.colors.black};
    }
  }

  ${(p) => p.theme.breakpoints.down("sm")} {
    left: 5px;
    bottom: 45px;
    svg {
      width: 35px;
      height: 35px;
    }
    p {
      font-size: 16px;
    }
  }
`

type HomePageProps = {
  homepageData: Homepage
}

const HomePage = ({ homepageData }: HomePageProps) => {
  const [stroyEventTriggered, setStoryEventTriggered] = useState(false)
  const secondElementRef = useRef(null)
  const scrollBtnRef = useRef(null)

  const handleSkipToEnd = () => {
    trackSkipStoryTwo()
    gsap.to(window, {
      duration: 10, // Duration of the scroll in seconds
      scrollTo: {
        y: secondElementRef.current,
        offsetY: 80,
      },
      ease: "power2.inOut", // Easing function for smoothness
    })
  }

  useEffect(() => {}, [scrollBtnRef])

  return (
    <>
      <div>
        <TopBanner data={homepageData.topBanner} />
      </div>

      <Story
        brandStory={homepageData.brandStory}
        resetSwiper={() => {
          setStoryEventTriggered((prev) => !prev)
        }}
        scrollBtnRef={scrollBtnRef}
        hasCampaign={!!homepageData.topBanner}
      />
      <StyledButton
        $campaign={!homepageData.topBanner}
        id="skipStory"
        variant="outlined"
        color="secondary"
        onClick={handleSkipToEnd}
        ref={scrollBtnRef}
      >
        <div>
          <Typography>
            <Typography variant="srOnly">בלחיצה </Typography>דלגו לדגמים
          </Typography>
        </div>
        <MoreInfoWhite />
      </StyledButton>
      <SwiperMain
        ref={secondElementRef}
        carsStrip={homepageData.homePageCarsStrip}
        resetSwiper={stroyEventTriggered}
      />
      <MazdaTools toolsData={homepageData.promotions} />
      <Blog blogData={homepageData.blogs} />
    </>
  )
}

export default HomePage
